import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useDoctoralCommitteeEdit } from '@/module/Author/DoctoralCommittee/model/DoctoralCommitteeQuery';
import {
  DoctoralCommitteeSchema,
  defaultDoctoralCommitteeValues,
  doctoralCommitteeSchema,
} from '@/module/Author/DoctoralCommittee/model/DoctoralCommitteeSchema';

import { useAppNotification } from '@feature/utils';

import { DoctoralCommitteeForm } from './DoctoralCommitteeForm';
import { DoctoralCommittee } from './model/DoctoralCommitteeTypes';

interface DoctoralCommitteeEditProps {
  doctoralCommittee: DoctoralCommittee;
}

const convert = (doctoralCommittee: DoctoralCommittee): DoctoralCommitteeSchema => ({
  ...doctoralCommittee,
});

export function DoctoralCommitteeEdit(props: DoctoralCommitteeEditProps) {
  const { doctoralCommittee } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useDoctoralCommitteeEdit(doctoralCommittee.id);

  const notification = useAppNotification();
  const onSubmit = (values: DoctoralCommitteeSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(doctoralCommittee), [doctoralCommittee]);
  const navigate = useNavigate();

  return (
    <DoctoralCommitteeForm
      title={t('doctoralCommittees.form.title.edit')}
      schema={doctoralCommitteeSchema}
      defaultValues={{
        ...defaultDoctoralCommitteeValues,
        type: doctoralCommittee.type,
      }}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
